import { all, put } from 'redux-saga/effects';
import { apiAction } from 'ctm-util-functions';
import { configModel } from '../app_config_model';

/**
 * Saga used to set form elements values from API actions.
 * @param {Object} action - The action that describes the requested validation and progression.
 */
export const processPreloadFormElementsApiValues = function* (action) {
    const apiEffects = [];
    const models = configModel.getModels();
    const allElements = models.formSchemaModel.allElements;

    // Get the components that have the API settings
    // preload is only for vertical.quote form elements
    allElements['vertical.quote'].forEach((field) => {
        if (field.api && field.api.onSetValue && field.api.onSetValue.preload) {
            apiEffects.push(put(apiAction(field.api.onSetValue, action.pageState)));
        }
    });

    // Dispatch all the API actions in parallel
    yield all(apiEffects);
};
